import _ from "lodash";
import { BRAND_ROUNDED_STYLE_TYPES, QUERY_PARAMETER_MODAL_IFRAME_ACTIVE } from "rylak-common/src/constants";

export const INGRID_HOME_SITE = "https://www.ingrid.com/";

export const ROUTES = {
    MAIN_BRAND_PATH: { pathname: "/[brand]", iframeEventPageName: "LOGIN" },
    SHOP_GROUP: { pathname: "/group/[merchantId]", iframeEventPageName: "LOGIN" },
    RETURN_PAGE: {
        pathname: "/[brand]/return",
        iframeEventPageName: "PRODUCTS_SELECT",
    },
    SHIPMENT_METHOD_PAGE: {
        pathname: "/[brand]/shipment-method",
        iframeEventPageName: "SHIPMENT_SELECT",
    },
    CONFIRMATION_PAGE: {
        pathname: "/[brand]/confirmation",
        iframeEventPageName: "CONFIRMATION",
    },
    SUCCESS_PAGE: {
        pathname: "/[brand]/success",
        iframeEventPageName: "SUCCESS",
    },
    STATUS: {
        pathname: "/[brand]/status/[order]",
        iframeEventPageName: "RETURN_STATUS",
    },
    STATUS_TRACKING_HELP: {
        pathname: "/[brand]/status-tracking-help/[order]",
        iframeEventPageName: "RETURN_STATUS",
    },
    PACKING_INSTRUCTIONS: {
        pathname: "/[brand]/packing-instructions",
        iframeEventPageName: "PACKING_INSTRUCTIONS",
    },
    PACKING_INSTRUCTIONS_ITEM: {
        pathname: "/[brand]/packing-instructions/[order]/item",
        iframeEventPageName: "PACKING_INSTRUCTIONS_ITEM",
    },
    COMPLAINT_IMAGE: {
        pathname: "/[brand]/complaint-image",
        iframeEventPageName: "COMPLAINT_IMAGE",
    },
    EXCHANGE_PAYMENT_BASE: {
        pathname: "/[brand]/exchange",
        iframeEventPageName: "EXCHANGE_PAYMENT_BASE",
    },
    EXCHANGE_PAYMENT: {
        pathname: "/[brand]/exchange/[orderToken]/payment",
        iframeEventPageName: "EXCHANGE_PAYMENT",
    },
    EXCHANGE_PAYMENT_COMPLETE: {
        pathname: "/[brand]/exchange/[orderToken]/payment-complete",
        iframeEventPageName: "EXCHANGE_PAYMENT_COMPLETE",
    },
    EXCHANGE_PAYMENT_FAILED: {
        pathname: "/[brand]/exchange/[orderToken]/payment-failed",
        iframeEventPageName: "EXCHANGE_PAYMENT_FAILED",
    },
    IFRAME_MODAL_APP: {
        pathname: "/[brand]/iframe-modal",
        iframeEventPageName: "IFRAME_MODAL_APP",
    },
};

export const CUSTOMS_TYPES = {
    NO_CUSTOMS: "NO_CUSTOMS",
    PLT: "PLT",
    CUSTOMS: "CUSTOMS",
};

export const APPS = {
    DEV_APP: "DEV_APP",
    DEMO_APP: "DEMO_APP",
    APP: "APP",
};

export const SERVER_SIDE_CACHE_KEYS = {
    INIT: "init",
};

export const QUERY_AND_SESSION_KEYS = {
    SELECTED_RETURN: "return",
    EMAIL: "email",
    IFRAME: "iframe",
    ORDER: "order",
    ACCEPT_POLICY: "accept_policy",
    HOST: "host",
    MOCK_TIMER: "mock_timer",
    KEY_MOCKED_SERVICES: "KEY_MOCKED_SERVICES",
    APP_ENVIRONMENT: "env",
    SUCCESS: "success",
    FORCE_REAL_RETURN_REASONS: "real_return_reasons",
    IFRAME_OPTION: "iframe-option",
    MODAL_IFRAME_ACTIVE: QUERY_PARAMETER_MODAL_IFRAME_ACTIVE,
    SHOW_INACTIVE_SHOPS: "SHOW_INACTIVE_SHOPS",
    SHOW_TEST_SHOPS: "SHOW_TEST_SHOPS",
    PAGE_TAB: "PAGE_TAB",
    WITHDRAWAL: "withdrawal",
};

export const RETURN_REASON_SETTINGS_TABS = {
    RETURN_REASONS: "RETURN_REASONS",
    RETURN_REASONS_ENTITY_ACTIONS: "RETURN_REASONS_ENTITY_ACTIONS",
    COMPLAINT_REASONS: "COMPLAINT_REASONS",
};

export const COLORS = {
    lightGray: "#cbcccb",
    errorRed: "#fa5252",
    textBlack: "#212529",
    textGray: "#495057",
    textLightGray: "#9b9b9b",
    lightGreen: "#7ed957",
};

export const MEDIA_SIZE_M = 768;

export const PRODUCT_PROPERTIES = {
    COLOUR: "COLOUR",
    SIZE: "SIZE",
};

export const REFUND_OPTIONS = {
    BASIC: "BASIC",
    FAST: "FAST",
    GIFT_CARD: "GIFT_CARD",
};

// Mirrors com.turnr.database.schema.shops.WithdrawalItemSelectionMode in Rasputin.
// Sent on the login/session response as `withdrawalItemSelectionMode` for withdrawal sessions.
export const WITHDRAWAL_ITEM_SELECTION_MODES = {
    INDIVIDUAL: "INDIVIDUAL",
    PRESELECT_ALL: "PRESELECT_ALL",
    WHOLE_ORDER_LOCKED: "WHOLE_ORDER_LOCKED",
};

// Mirrors com.turnr.database.schema.shops.WithdrawalShipmentMode in Rasputin.
// Sent on the login/session response as `withdrawalShipmentMode` for withdrawal sessions.
export const WITHDRAWAL_SHIPMENT_MODES = {
    OFFER_SHIPPING: "OFFER_SHIPPING",
    ACKNOWLEDGMENT_ONLY: "ACKNOWLEDGMENT_ONLY",
};

export const BRAND_TYPES = {
    SHOPIFY: "SHOPIFY",
    CENTRA: "CENTRA",
};

export const RETURN_METHOD_EXCHANGE = "EXCHANGE";
export const RETURN_METHOD_RETURN = "RETURN";
export const RETURN_METHOD_COMPLAINT = "COMPLAINT";
export const RETURN_METHOD_RESALE = "RESALE";
export const RETURN_METHOD_SERVICE = "SERVICE";
export const SERVICE_TYPE_RETURN = "RETURN";

export const SESSION_STORAGE_KEY_LANGUAGE = "lang";

//TODO Replace this with rylak common. This is stupidly duplicated right now :)
export const LANGUAGE_EN = "EN";
export const LANGUAGE_EN_TR = "EN_TR";
export const LANGUAGE_SV = "SV";
export const LANGUAGE_DE = "DE";
export const LANGUAGE_NO = "NO";
export const LANGUAGE_FR = "FR";
export const LANGUAGE_ES = "ES";

export const LANGUAGE_OPTIONS = [
    {
        label: "Bahasa Indonesia",
        value: "ID",
        icon: "/icons/country-flags/id.svg",
    },
    {
        label: "Čeština",
        value: "CS",
        icon: "/icons/country-flags/cz.svg",
    },
    {
        label: "Dansk",
        value: "DA",
        icon: "/icons/country-flags/dk.svg",
    },
    {
        label: "Deutsch",
        value: LANGUAGE_DE,
        icon: "/icons/country-flags/de.svg",
    },
    {
        label: "Deutsch (Österreich)",
        value: "DE_AT",
        icon: "/icons/country-flags/at.svg",
    },
    {
        label: "Eesti keel",
        value: "ET",
        icon: "/icons/country-flags/ee.svg",
    },
    {
        label: "English",
        value: LANGUAGE_EN,
        icon: "/icons/country-flags/gb.svg",
    },
    {
        label: "Español",
        value: LANGUAGE_ES,
        icon: "/icons/country-flags/es.svg",
    },
    {
        label: "Eλληνικά",
        value: "EL",
        icon: "/icons/country-flags/gr.svg",
    },
    {
        label: "Français",
        value: LANGUAGE_FR,
        icon: "/icons/country-flags/fr.svg",
    },
    {
        label: "Français (Belgique)",
        value: "FR_BE",
        icon: "/icons/country-flags/be.svg",
    },
    {
        label: "Gaeilge",
        value: "GA",
        icon: "/icons/country-flags/ie.svg",
    },
    {
        label: "Hrvatski",
        value: "HR",
        icon: "/icons/country-flags/hr.svg",
    },
    {
        label: "Italiano",
        value: "IT",
        icon: "/icons/country-flags/it.svg",
    },
    {
        label: "Kiswahili",
        value: "SW",
        icon: "/icons/country-flags/ke.svg",
    },
    {
        label: "Latviešu valoda",
        value: "LV",
        icon: "/icons/country-flags/lv.svg",
    },
    {
        label: "Lietuvių kalba",
        value: "LT",
        icon: "/icons/country-flags/lt.svg",
    },
    {
        label: "Magyar",
        value: "HU",
        icon: "/icons/country-flags/hu.svg",
    },
    {
        label: "Malti",
        value: "MT",
        icon: "/icons/country-flags/mt.svg",
    },
    {
        label: "Nederlands",
        value: "NL",
        icon: "/icons/country-flags/nl.svg",
    },
    {
        label: "Nederlands (België)",
        value: "NL_BE",
        icon: "/icons/country-flags/be.svg",
    },
    {
        label: "Norsk",
        value: LANGUAGE_NO,
        icon: "/icons/country-flags/no.svg",
    },
    {
        label: "Polski",
        value: "PL",
        icon: "/icons/country-flags/pl.svg",
    },
    {
        label: "Português",
        value: "PT",
        icon: "/icons/country-flags/pt.svg",
    },
    {
        label: "Român",
        value: "RO",
        icon: "/icons/country-flags/ro.svg",
    },
    {
        label: "Slovak",
        value: "SK",
        icon: "/icons/country-flags/sk.svg",
    },
    {
        label: "Slovenčina",
        value: "SL",
        icon: "/icons/country-flags/si.svg",
    },
    {
        label: "Suomi",
        value: "FI",
        icon: "/icons/country-flags/fi.svg",
    },
    {
        label: "Svenska",
        value: LANGUAGE_SV,
        icon: "/icons/country-flags/se.svg",
    },
    {
        label: "Tiếng việt",
        value: "VIE",
        icon: "/icons/country-flags/vn.svg",
    },
    {
        label: "български",
        value: "BG",
        icon: "/icons/country-flags/bg.svg",
    },
    {
        label: "हिन्दी",
        value: "HI",
        icon: "/icons/country-flags/in.svg",
    },
    {
        label: "বাংলা",
        value: "BEN",
        icon: "/icons/country-flags/bd.svg",
    },
    {
        label: "中文",
        value: "ZH",
        icon: "/icons/country-flags/cn.svg",
    },
    {
        label: "日本語",
        value: "JA",
        icon: "/icons/country-flags/jp.svg",
    },
    {
        label: "한국어",
        value: "KOR",
        icon: "/icons/country-flags/kr.svg",
    },
];

export const NO_CONFETTI = "NO_CONFETTI";
export const CONFETTI = "CONFETTI";
export const BALLS = "BALLS";

export const ENV_VARIABLES_VERCEL = {
    RETURNS_PROD: "returns-prod",
    RETURNS_STAGING: "returns-stage",
    RETURNS_DEV: "returns-dev",
    RETURNS_OTHER: "returns-other",
    DEMO_PROD: "demo-prod",
    DEMO_STAGING: "demo-stage",
    DEMO_DEV: "demo-dev",
    DEMO_OTHER: "demo-other",
};

export const COOKIE_CONSENT_NAME = "turnrConsentCookieValue";

// export const PRIVACY_POLICY_URL = "https://www.turnr.se/privacy-policy";

export const EXCHANGE_POLICY = {
    IMMEDIATE_EXCHANGE: "IMMEDIATE_EXCHANGE", // "Has been processed and is on its way",
    EXCHANGE_ON_RETURN: "EXCHANGE_ON_RETURN", // "When the return is completed at the warehouse the exchange will be shipped out"
    MANUAL_APPROVAL: "MANUAL_APPROVAL", // "The store will approve the exchange before it's shipped out",
    EXCHANGE_ON_SHIPMENT: "EXCHANGE_ON_SHIPMENT", // "When the return shipment is initiated. The exchange will shipped out"
    EXCHANGE_ON_ARRIVED_AT_WAREHOUSE: "EXCHANGE_ON_ARRIVED_AT_WAREHOUSE", // "When the return has arrived at the warehouse the exchange will be shipped out"
};

export const ORDER_ID_LABELS = {
    ORDER_ID: "ORDER_ID",
    ORDER_NUMBER: "ORDER_NUMBER",
};

const SHARP_OPTION = { value: BRAND_ROUNDED_STYLE_TYPES.SHARP, label: "Sharp" };
const SLIGHTLY_ROUNDED_OPTION = {
    value: BRAND_ROUNDED_STYLE_TYPES.SLIGHTLY_ROUNDED,
    label: "Slightly rounded",
};
const ROUNDED_OPTION = {
    value: BRAND_ROUNDED_STYLE_TYPES.ROUNDED,
    label: "Rounded",
};
const VERY_ROUNDED_OPTION = {
    value: BRAND_ROUNDED_STYLE_TYPES.VERY_ROUNDED,
    label: "Largely rounded",
};
const FULLY_ROUNDED_OPTION = {
    value: BRAND_ROUNDED_STYLE_TYPES.FULLY_ROUNDED,
    label: "Fully rounded",
};

export const INPUT_VARIANT_OPTIONS_MAP = {
    DEFAULT: {
        value: "DEFAULT",
        label: "Default",
    },
    SHIFTER_LINE: {
        value: "SHIFTER_LINE",
        label: "ShifterLine",
    },
};

export const BUTTON_VARIANT_OPTIONS_MAP = {
    SOLID: {
        value: "SOLID",
        label: "Solid",
    },
    OUTLINED: {
        value: "OUTLINED",
        label: "Outlined",
    },
};

export const BUTTON_EFFECT_OPTIONS_MAP = {
    ALL_EFFECTS: {
        value: "ALL_EFFECTS",
        label: "Hover & click effects",
    },
    NO_EFFECTS: {
        value: "NO_EFFECTS",
        label: "No effects",
    },
};

// const BUTTON_EFFECT_NO_EFFECTS = {
//     value: "BUTTON_EFFECT_NO_EFFECTS",
//     label: "No effects",
// };

export const BUTTON_TEXT_OPTIONS_MAP = {
    DEFAULT_CASE: {
        value: "DEFAULT_CASE",
        label: "Default case",
    },
    LOWER_CASE: {
        value: "LOWER_CASE",
        label: "lower case",
    },
    PASCAL_CASE: {
        value: "PASCAL_CASE",
        label: "Pascal Case",
    },
    UPPER_CASE: {
        value: "UPPER_CASE",
        label: "CAPITAL CASE",
    },
};

export const BUTTON_THICKNESS_OPTIONS_MAP = {
    300: {
        value: 300,
        label: "Thin",
    },
    500: {
        value: 500,
        label: "Medium",
    },
    700: {
        value: 700,
        label: "Thick",
    },
};

export const BUTTON_THICKNESS_OPTIONS = _.values(BUTTON_THICKNESS_OPTIONS_MAP);

export const BUTTON_TEXT_OPTIONS = _.values(BUTTON_TEXT_OPTIONS_MAP);

export const BUTTON_EFFECT_OPTIONS = _.values(BUTTON_EFFECT_OPTIONS_MAP);

export const BUTTON_VARIANT_OPTIONS = _.values(BUTTON_VARIANT_OPTIONS_MAP);

export const INPUT_VARIANT_OPTIONS = _.values(INPUT_VARIANT_OPTIONS_MAP);

export const BUTTON_TYPE_OPTIONS = [SHARP_OPTION, SLIGHTLY_ROUNDED_OPTION, ROUNDED_OPTION, VERY_ROUNDED_OPTION, FULLY_ROUNDED_OPTION];

export const INPUT_TYPES_OPTIONS = [SHARP_OPTION, SLIGHTLY_ROUNDED_OPTION, ROUNDED_OPTION, VERY_ROUNDED_OPTION];

export const OVERALL_TYPES_OPTIONS = [SHARP_OPTION, SLIGHTLY_ROUNDED_OPTION, ROUNDED_OPTION, VERY_ROUNDED_OPTION];

export const WINDOW_TYPES_OPTIONS = [SHARP_OPTION, SLIGHTLY_ROUNDED_OPTION, ROUNDED_OPTION, VERY_ROUNDED_OPTION];

export const CHECKBOX_TYPE_OPTIONS = [SHARP_OPTION, SLIGHTLY_ROUNDED_OPTION, ROUNDED_OPTION, VERY_ROUNDED_OPTION, FULLY_ROUNDED_OPTION];
